import { createStore } from "vuex";

export default createStore({
  state: {
    isBind: false, // 是否绑定了
    isVerify: false, //是否验证了
    userInfo: {},
  },
  getters: {
    isBind: (state) => state.isBind,
    isVerify: (state) => state.isVerify,
    userInfo: (state) => state.userInfo,
  },
  mutations: {
    setBind(state, isBind) {
      state.isBind = isBind;
    },
    setVerify(state, isVerify) {
      state.isVerify = isVerify;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
  },
  actions: {
    setBind({ commit }, isBind) {
      commit("setBind", isBind);
    },
    getVerify({ commit }) {
      // commit("setVerify", true);
      commit("setVerify", false);
    },
  },
});
